import React from "react";
import { Link, NavLink, useLocation, withRouter } from "react-router-dom";

import { Button, Icon } from "@culturehq/components";
import { getProfilePath } from "app/links";
import { isCurrentRoute, t, Trans } from "app/utils";

const ConnectionsOptions = withRouter(({ user, isProfile }) => {
  const location = useLocation();
  const baseUrl = isProfile ? "/profile" : getProfilePath(user);

  return (
    <div className="row">
      <div className="col-sm-12 Community--SubNav">
        <div role="tablist" aria-label={t("User community options")} className="nav nav-tabs user-community-tabs">
          <NavLink
            role="tab"
            aria-selected={isCurrentRoute("/profile/community/following", location, true)}
            to={`${baseUrl}/community/following`}
            exact
            activeClassName="active"
          >
            <Trans>Following</Trans>
          </NavLink>
          <NavLink
            role="tab"
            aria-selected={isCurrentRoute("/profile/community/followers", location, true)}
            to={`${baseUrl}/community/followers`}
            exact
            activeClassName="active"
          >
            <Trans>Followers</Trans>
          </NavLink>
        </div>
        <div className="hidden-xs">
          <Button as={Link} to={`${getProfilePath(user)}/network`}>
            <Icon icon="people" />
            <Trans>
              View Network <small>(Beta)</small>
            </Trans>
          </Button>
        </div>
      </div>
    </div>
  );
});

export default ConnectionsOptions;
